import LegalPageLayout from '../components/LegalPageLayout';
import { LEGAL } from '../lib/legalConstants';

export default function TermsOfService() {
  return (
    <LegalPageLayout
      title="Conditions d'utilisation"
      subtitle={`${LEGAL.appName} — ${LEGAL.appUrl}`}
    >
      <p className="legal-meta">Dernière mise à jour : {LEGAL.lastUpdated}</p>

      <h2>1. Objet</h2>
      <p>
        Les présentes conditions régissent l&apos;accès et l&apos;utilisation de{' '}
        {LEGAL.appName}, application web de jeu de Tarot en ligne accessible à l&apos;adresse{' '}
        {LEGAL.appUrl}, éditée par {LEGAL.companyLegalName} ({LEGAL.companyForm}, SIRET{' '}
        {LEGAL.siret}, RCS {LEGAL.rcs}), siège social : {LEGAL.registeredOffice}.
      </p>
      <p>
        En créant un compte, en vous connectant (y compris via Google ou Facebook) ou en
        utilisant le service, vous acceptez sans réserve les présentes conditions. Si vous
        n&apos;y souscrivez pas, n&apos;utilisez pas {LEGAL.appName}.
      </p>

      <h2>2. Description du service</h2>
      <p>
        {LEGAL.appName} permet de jouer au Tarot en ligne, d&apos;accéder au chat, aux
        tables de jeu, aux classements et, selon votre abonnement et licence, à l&apos;espace
        Compétition. Le service s&apos;appuie sur l&apos;infrastructure et les comptes
        joueurs de la plateforme {LEGAL.brand}, dont le site principal est{' '}
        <a href={LEGAL.mainSiteUrl} target="_blank" rel="noopener noreferrer">
          {LEGAL.mainSiteUrl}
        </a>.
      </p>

      <h2>3. Compte utilisateur</h2>
      <ul>
        <li>
          L&apos;accès au jeu en ligne requiert un pseudo {LEGAL.brand}. Vous pouvez en
          créer un nouveau ou rattacher un compte existant à votre adresse e-mail (notamment
          lors d&apos;une connexion OAuth).
        </li>
        <li>
          Vous êtes responsable de la confidentialité de votre mot de passe et de toute
          activité réalisée sous votre pseudo.
        </li>
        <li>
          Les informations fournies (pseudo, e-mail, identité) doivent être exactes. Un
          pseudo usurpé, offensant ou contraire aux règles peut entraîner la suspension
          ou la suppression du compte.
        </li>
        <li>
          Le nombre de pseudos associés à une même adresse e-mail peut être limité (actuellement
          cinq comptes par adresse pour les connexions OAuth).
        </li>
      </ul>

      <h2>4. Connexion via Google, Facebook ou autre fournisseur</h2>
      <p>
        Lorsque vous utilisez un bouton de connexion tierce, vous autorisez {LEGAL.companyName}
        à recevoir les informations permises par le fournisseur (typiquement adresse e-mail,
        nom et identifiant). Ces données servent uniquement à l&apos;authentification et à la
        gestion de votre compte, conformément à notre{' '}
        <a href="/confidentialite">politique de confidentialité</a>.
      </p>

      <h2>5. Licence, abonnement et période d&apos;évaluation</h2>
      <p>
        L&apos;accès aux parties en ligne et aux fonctionnalités avancées peut nécessiter
        une licence {LEGAL.brand} et, pour l&apos;espace Compétition, un abonnement en cours
        de validité. Les modalités d&apos;achat historiques (chèque, virement, carte bancaire
        Crédit Mutuel) restent disponibles sur{' '}
        <a href="https://boutique.webtarot.fr/cgv.php" target="_blank" rel="noopener noreferrer">
          boutique.webtarot.fr
        </a>{' '}
        ; un nouveau parcours d&apos;abonnement par carte bancaire est également proposé
        sur {LEGAL.appName} via notre prestataire de paiement Stripe.
      </p>
      <p>
        <strong>Essai gratuit</strong> : un essai gratuit de 15 jours à l&apos;Espace
        Compétition peut être proposé. Cet essai est limité à <strong>un par identité
        OAuth ou adresse e-mail vérifiée</strong>, indépendamment du nombre de pseudos.
        Toute tentative de contournement (création de comptes multiples pour cumuler des
        essais) peut entraîner la suspension du compte. Au terme de l&apos;essai, si
        une carte bancaire a été enregistrée, le premier prélèvement est effectué
        automatiquement ; vous pouvez résilier à tout moment depuis la page « Mon
        abonnement » avant cette date.
      </p>
      <p>
        <strong>Résiliation et remboursement</strong> : vous pouvez résilier votre
        abonnement Stripe à tout moment depuis la page « Mon abonnement ». La
        résiliation prend effet à la fin de la période en cours déjà payée. Aucun
        remboursement au prorata n&apos;est dû en cas de résiliation anticipée, sauf
        obligations légales contraires (droit de rétractation de 14 jours pour les
        consommateurs, sauf accès immédiat aux services numériques avec consentement
        exprès).
      </p>

      <h2>6. Règles de conduite</h2>
      <p>
        Vous vous engagez à adopter un comportement courtois envers les autres joueurs.
        Sont notamment interdits : insultes, harcèlement, propos discriminatoires,
        triche, usurpation d&apos;identité et tout agissement portant atteinte au bon
        déroulement des parties ou au chat.
      </p>
      <p>
        <strong>Tournois différés et compétition</strong> : il est strictement interdit
        de rejouer une donne de compétition différée sous un second pseudo (l&apos;avantage
        tiré de la connaissance préalable de la donne fausse les classements). Pour
        faire respecter cette règle, {LEGAL.appName} enregistre une empreinte technique
        de votre appareil au moment où vous démarrez une donne ; les modalités précises
        sont décrites à la section 11.1 de la{' '}
        <a href="/confidentialite">politique de confidentialité</a>. Toute violation
        avérée peut entraîner l&apos;invalidation des scores concernés, voire la
        suspension du compte.
      </p>
      <p>
        La{' '}
        <a href={LEGAL.ethicsUrl} target="_blank" rel="noopener noreferrer">
          charte d&apos;éthique du jeu {LEGAL.brand}
        </a>{' '}
        complète les présentes conditions et décrit les bonnes pratiques attendues sur
        les tables et le chat global. Les modérateurs et l&apos;équipe {LEGAL.brand} peuvent
        appliquer des mesures graduées (avertissement, exclusion temporaire ou définitive).
      </p>

      <h2>7. Contenus et propriété intellectuelle</h2>
      <p>
        {LEGAL.appName}, le logiciel {LEGAL.brand}, les graphismes, les cartes, les textes
        et la marque {LEGAL.brand} sont protégés par le droit de la propriété intellectuelle.
        Toute reproduction ou exploitation non autorisée est interdite.
      </p>
      <p>
        Vous conservez vos droits sur les contenus que vous publiez (messages, avatar,
        éléments de profil), tout en accordant à {LEGAL.companyName} une licence non exclusive
        permettant leur affichage dans le cadre du service.
      </p>

      <h2>8. Disponibilité et évolutions</h2>
      <p>
        {LEGAL.companyName} s&apos;efforce d&apos;assurer la disponibilité de {LEGAL.appName}
        mais ne garantit pas un fonctionnement ininterrompu. Le service peut être modifié,
        suspendu pour maintenance ou évoluer (nouvelles fonctionnalités, compatibilité avec
        les serveurs de jeu) sans préavis, sous réserve des droits acquis liés à une licence
        ou un abonnement payant.
      </p>

      <h2>9. Limitation de responsabilité</h2>
      <p>
        Dans les limites autorisées par la loi, {LEGAL.companyName} ne saurait être tenue
        responsable des dommages indirects, pertes de données ou interruptions liées à
        votre équipement, votre connexion Internet ou des services de tiers (fournisseurs
        OAuth, hébergeurs). La responsabilité de {LEGAL.companyName} est, le cas échéant,
        limitée au montant des sommes versées par l&apos;utilisateur au cours des douze
        derniers mois pour les services concernés.
      </p>

      <h2>10. Résiliation</h2>
      <p>
        Vous pouvez cesser d&apos;utiliser {LEGAL.appName} à tout moment. Vous pouvez
        demander la suppression de votre compte en écrivant à{' '}
        <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>.
      </p>
      <p>
        {LEGAL.companyName} se réserve le droit de suspendre ou supprimer un compte en cas
        de violation des présentes conditions ou de la charte d&apos;éthique, sans
        préjudice des autres recours.
      </p>

      <h2>11. Données personnelles</h2>
      <p>
        Le traitement de vos données personnelles est décrit dans notre{' '}
        <a href="/confidentialite">politique de confidentialité</a>.
      </p>

      <h2>12. Droit applicable et litiges</h2>
      <p>
        Les présentes conditions sont soumises au droit français. En cas de litige, et
        après tentative de résolution amiable auprès de{' '}
        <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>, les tribunaux
        français seront seuls compétents, sous réserve des règles impératives applicables
        aux consommateurs.
      </p>

      <h2>13. Contact</h2>
      <p>
        {LEGAL.companyName} — {LEGAL.registeredOffice}
        <br />
        E-mail : <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>
      </p>
    </LegalPageLayout>
  );
}
